import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const ShiftCreateForm= React.lazy(()=>import('./NewShifts'))
const ShiftEditPage= React.lazy(()=>import('./EditShifts'));
const ShiftListingPage= React.lazy(()=>import('./ShiftListing'))
const ShiftDetailPage= React.lazy(()=>import('./NewShiftsDetails'));


export const ShiftsConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift/create',
    element: <ShiftCreateForm />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift/edit/:id',
    element: <ShiftEditPage />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/shift/details/:id',
    element: <ShiftDetailPage/>,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/shift/list',
    element: <ShiftListingPage/>,
  },
 

];
